import { getFilterNestedField } from "./getFilterNestedField.js";
const splitCompositeFilterPath = (path) => {
  const field = getFilterNestedField(path);
  if (!field) {
    const [resolvedPath2, collectionId] = path.split(".");
    if (!collectionId) {
      return { path: resolvedPath2 };
    }
    return {
      path: resolvedPath2,
      field: {
        key: "collection_id",
        value: collectionId
      }
    };
  }
  const [resolvedPath] = path.split("[");
  return {
    path: resolvedPath,
    field
  };
};
export {
  splitCompositeFilterPath
};
